import * as BasketUpdated from '@ori-events/basket-updated';
import * as RemoveBasketItem from '@ori-events/remove-basket-item';
import type { Placement } from '@ori/analytics-data';

interface RemoveBasketItemData extends RemoveBasketItem.Data {
  previousQuantity?: number;
  itemCode: string;
  placement: Placement;
}

export const removeBasketItem = async (detail: RemoveBasketItemData) =>
  new Promise<void>((resolve) => {
    const handleResolve = (() => {
      window.removeEventListener(BasketUpdated.Name, handleResolve);
      resolve();
    }) as EventListener;

    window.addEventListener(BasketUpdated.Name, handleResolve);

    const event = new CustomEvent<RemoveBasketItemData>(RemoveBasketItem.Name, {
      detail,
    });
    window.dispatchEvent(event);
  });
